import Rating from "./Rating";
class Ratings {
    unrated;
    values;
    constructor(response) {
        this.unrated = response.unrated;
        this.values = response.values?.map(v => new Rating(v));
    }
    print() {
        if (this.unrated) {
            return 'Unrated';
        }
        const values = this.values ?? [];
        if (values.filter((r) => r.agency !== undefined).length === 0) {
            const text = values.map((r) => r.value);
            return text.join('/');
        }
        const moodys = values.find((r) => r.agency === 'MOODYS');
        const sp = values.find((r) => r.agency === 'S_P');
        const fitch = values.find((r) => r.agency === 'FITCH');
        const text = [];
        if (moodys !== undefined) {
            text.push(moodys.value);
        }
        if (sp !== undefined && sp.value !== '') {
            const suffix = typeof fitch === 'undefined' && typeof moodys === 'undefined' ? ' (S&P)' : '';
            text.push(sp.value + suffix);
        }
        else if (fitch !== undefined && moodys !== undefined) {
            text.push('-');
        }
        if (typeof fitch !== 'undefined' && fitch.value !== '') {
            const suffix = typeof sp === 'undefined' && typeof moodys === 'undefined' ? ' (Fitch)' : '';
            text.push(fitch.value + suffix);
        }
        else if (typeof sp !== 'undefined' && typeof moodys !== 'undefined') {
            text.push('-');
        }
        return text.join('/');
    }
    ;
}
export default Ratings;
